export default __webpack_public_path__ + "static/media/userDefaultAvatar.1ddf0836.png";